import { useEffect } from 'react';

/**
 * Atualiza dinamicamente o <link rel="manifest"> para que o PWA
 * seja instalado com o start_url correto (ex: /conferente/:cnpj).
 *
 * Necessário porque o manifest.json estático tem start_url fixo,
 * mas cada transportadora tem seu próprio slug CNPJ.
 */
export function useDynamicManifest(startUrl: string) {
  useEffect(() => {
    if (!startUrl) return;

    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) return;

    const originalHref = link.href;

    // Buscar o manifest estático e criar uma versão com start_url customizado
    fetch('/manifest.json')
      .then(res => res.json())
      .then(manifest => {
        const customManifest = { ...manifest, start_url: startUrl };
        const blob = new Blob([JSON.stringify(customManifest)], { type: 'application/json' });
        const blobUrl = URL.createObjectURL(blob);
        link.setAttribute('href', blobUrl);

        // Guardar referência para cleanup
        (link as any).__blobUrl = blobUrl;
      })
      .catch(() => {
        // Se falhar, manter o manifest original - PWA ainda funciona
      });

    return () => {
      const blobUrl = (link as any).__blobUrl;
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
        delete (link as any).__blobUrl;
      }
      link.setAttribute('href', originalHref);
    };
  }, [startUrl]);
}
